// @flow
import { decodeAuthToken } from 'utils/auth';
import { AUTH_SET_SUBSCRIPTIONS } from 'actions/auth';

export type Subscription = {|
  +active: boolean,
  +canceled: boolean,
  +deleted_at: ?string,
  +expire_at: ?string,
  +id: number,
  +plan_code: string,
  +plan_id: number,
  +processing_status: string,
|};

export type AuthTokenData = {|
  +email: string,
  +exp: number,
  +id: string,
  +name: string,
|};

export type State = {|
  +authTokenData: ?AuthTokenData,
  +subscriptions: ?Array<Subscription>,
|};

const INITIAL_STATE: State = {
  authTokenData: decodeAuthToken(),
  subscriptions: null,
};

export default function reduce(
  state: State = INITIAL_STATE,
  { type, ...payload }
) {
  switch (type) {
    case AUTH_SET_SUBSCRIPTIONS: {
      const { subscriptions } = payload;
      return {
        ...state,
        subscriptions,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/auth.js